module.exports = __webpack_public_path__ + "img/private-school.c4d7f2ec.svg";